<template>
	<div class="map-container" ref="mapContainer"></div>
</template>

<script>
	export default {
	  props: {
	    center: {
	      type: Array,
	      default: () => [124.334301,40.063369], // 默认中心点坐标
	    },
	    zoom: {
	      type: Number,
	      default: 13, // 默认缩放级别
	    },
	  },
	  mounted() {
	    this.initMap();
	  },
	  methods: {
	    initMap() {
	      // 引入高德地图API
	      const script = document.createElement('script');
	      script.src = `https://webapi.amap.com/maps?v=2.0&key=988ccd6e3c129aa7e44308b9d8b7877e&plugin=AMap.Marker`;
	      script.async = true;
	      script.onload = () => {
	        this.createMap();
	      };
	      document.head.appendChild(script);
	    },
	    createMap() {
	      // 创建地图实例
	      const map = new AMap.Map(this.$refs.mapContainer, {
	        center: this.center,
	        zoom: this.zoom,
	      });
	      // 添加标记
	      const marker = new AMap.Marker({
	        position: this.center,
	        map: map,
	      });
	      // 监听标记点击事件
	      marker.on('click', () => {
	        this.$emit('markerClick', marker);
	      });
	    },
	  },
	};
	
</script>

<style scoped>
.map-container {
  width: 100%;
  height: 300px;
}

@media (min-width: 960px) {
  .map-container {
    height: 600px;
  }
}
</style>